<template>
  <!--  <div style="background-color: #eaeaea">-->
  <div style="background-color: #fff">
    <div style="display: flex;">
      <!-- 顶部工具栏     -->
      <div style="flex: 1;height: 3vh;border-bottom: 1px solid #dce3e8;">
        <div style="float: right">
          <el-tag type="danger"> 比例尺 ：{{ SCALE }}</el-tag>

        </div>
      </div>
    </div>


    <div style="display: flex">
      <!--  左侧工具栏    -->
      <div id="tool" :style="{ height: '81vh', width: '230px',borderRight: '1px solid #dce3e8' }">
        <div style="height: 30px">工具栏</div>
        <div id="layout" style="display: flex; flex-direction: column;">
          <div style="margin-left: 20px;height: 50px">
            <div id="startNode" v-drag class="node">
              <i class="el-icon-switch-button"></i>
              开始节点
            </div>
          </div>
          <div style="margin-left: 20px;height: 50px">
            <div id="flowNode" v-drag class="node">
              <i class="el-icon-switch-button"></i>
              流程节点
            </div>
          </div>
          <div style="margin-left: 20px;height: 50px">
            <div id="endNode" v-drag class="node">
              <i class="el-icon-switch-button"></i>
              结束节点
            </div>
          </div>
        </div>
      </div>


      <!--   右侧画布加节点信息面板    -->
      <div style="flex: 1">
        <div style="display: flex; flex-direction: column;">
          <!--   画布    -->
          <div style="height: 30px;border-bottom: 1px solid #dce3e8;">画布</div>
          <div id="canvs" ref="canvs" style="height: 50vh;border-bottom: 1px solid #dce3e8;overflow:auto">
            <svg id="dagSvg" width="1000%" height="1000%">
              <g v-for="item in nodeData" :id="'group' + item.id" :key="item.id">
                <!--添加外点矩形-->
                <rect
                  :id="'outRect' + item.id"
                  :height="Rectangle.height + outNodeMargin * 2"
                  :width="Rectangle.width + outNodeMargin * 2"
                  fill="transparent"
                  stroke="#E0E3E7"
                  stroke-dasharray="10"
                  stroke-width="0"
                  :transform="`translate(${item.left - outNodeMargin}, ${item.top - outNodeMargin})`"
                >
                </rect>
                <!--添加文字-->
                <text
                  :id="'text' + item.id"
                  :x="item.left + Rectangle.width / 4"
                  :y="item.top + Rectangle.height * 0.7"
                  font-family="Verdana"
                  font-size="12"
                  fill=""
                  text-anchor="start"
                  cursor="move"
                >
                  {{ item.name }}
                </text>
                <!--添加矩形节点-->
                <rect
                  :id="'node' + item.id"
                  class="rectNode"
                  rx="4"
                  ry="4"
                  :height="Rectangle.height"
                  :width="Rectangle.width"
                  fill="transparent"
                  stroke="#E0E3E7"
                  stroke-width="1"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  cursor="move"
                  :transform="`translate(${item.left}, ${item.top})`"
                >
                </rect>
<!--                <g :id="'outCircle' + item.id">-->
<!--                  &lt;!&ndash;添加锚点的吸附点 (上下左右）&ndash;&gt;-->
<!--                  <circle :r="outNodeMargin" :cx="item.left + Rectangle.width / 2" :cy="item.top" fill="none" cursor="inherit" stroke="#E0E3E7" stroke-dasharray="10" stroke-width="1"></circle>-->
<!--                  <circle :r="outNodeMargin" :cx="item.left + Rectangle.width / 2" :cy="item.top + Rectangle.height" fill="none" cursor="inherit" stroke="#E0E3E7" stroke-dasharray="10" stroke-width="1"></circle>-->
<!--                  <circle :r="outNodeMargin" :cx="item.left" :cy="item.top + Rectangle.height / 2" fill="none" cursor="inherit" stroke="#E0E3E7" stroke-dasharray="10" stroke-width="1"></circle>-->
<!--                  <circle :r="outNodeMargin" :cx="item.left + Rectangle.width" :cy="item.top + Rectangle.height / 2" fill="none" cursor="inherit" stroke="#E0E3E7" stroke-dasharray="10" stroke-width="1"></circle>-->
<!--                </g>-->

                <g :id="'anchor' + item.id">
                  <!--添加锚点 (上下左右）-->
                  <circle r="2" :cx="item.left + Rectangle.width / 2" :cy="item.top" fill="transparent" cursor="inherit"></circle>
                  <circle r="2" :cx="item.left + Rectangle.width / 2" :cy="item.top + Rectangle.height" fill="transparent" cursor="inherit"></circle>
                  <circle r="2" :cx="item.left" :cy="item.top + Rectangle.height / 2" fill="transparent" cursor="inherit"></circle>
                  <circle r="2" :cx="item.left + Rectangle.width" :cy="item.top + Rectangle.height / 2" fill="transparent" cursor="inherit"></circle>
                </g>

              </g>
              <path
                v-for="(item, index) in pathPoint"
                :id="item.id"
                :key="index"
                :d="item.path"
                stroke="steelblue"
                stroke-width="2"
                fill="none"
                marker-end="url(#arrow)"
              ></path>
            </svg>
          </div>
          <!--   底部面板     -->
          <div style="flex: 1">
            <el-tabs v-model="activeName" type="border-card">
              <el-tab-pane label="节点信息" name="nodeInfo">
                <el-col :span="6">
                  <DataForm
                    :max="SCALE"
                    :form-data="formData"
                    :form-label="formLabel">
                  </DataForm>
                </el-col>
              </el-tab-pane>
              <el-tab-pane label="工作组" name="groupPeople">
              </el-tab-pane>
            </el-tabs>
          </div>
        </div>

      </div>
    </div>
  </div>


</template>

<script>
import * as d3 from 'd3'
import DataForm from './NodeDataForm'
export default {
  name: 'panel3',
  components: {
    DataForm
  },
  directives: {
    drag: {
      // 指令的定义
      bind: function(el, binding, vnode) {
        const odiv = el //获取当前元素
        //获取当前的vm实例
        const that = vnode.context
        el.onmousedown = (e) => {
          //算出鼠标相对元素的位置
          const disX = e.clientX - odiv.offsetLeft
          const disY = e.clientY - odiv.offsetTop
          console.log('e.clientY', e.clientY)
          console.log('odiv.offsetTop', odiv.offsetTop)
          const parDiv = odiv.parentNode
          const newDiv = odiv.cloneNode(true)
          parDiv.appendChild(newDiv)
          let left = ''
          let top = ''
          document.onmousemove = (e) => {
            //用鼠标的位置减去鼠标相对元素的位置，得到元素的位置
            left = e.clientX - disX
            top = e.clientY - disY
            //绑定元素位置到positionX和positionY上面
            if (top < 0 || left < odiv.offsetLeft + 230 - 20) {
              newDiv.style.cursor = 'not-allowed'
              that.appendNode = false
            } else {
              newDiv.style.cursor = 'inherit'
              that.appendNode = true
            }
            //移动当前元素
            newDiv.style.left = left + 'px'
            newDiv.style.top = top + 'px'
          }
          document.onmouseup = (e) => {
            document.onmousemove = null
            document.onmouseup = null
            that.appendSvgNode(newDiv, parDiv, e, odiv)
          }
        }
      }
    }
  },
  data() {
    return {
      //new
      SCALE: 100,
      activeName: 'nodeInfo',
      formData: {},
      formLabel: [
        {
          label: '节点名称',
          prop: 'name',
          readonly: false
        },
        {
          label: '比例天数',
          prop: 'scaleDays',
          readonly: false,
          type: 'number'
        },
        {
          label: '固定天数',
          prop: 'fixedDays',
          readonly: false,
          type: 'number'
        },
        {
          label: '提前天数',
          prop: 'advanceDays',
          readonly: false,
          type: 'number'
        },
        {
          label: '延后天数',
          prop: 'delayedDays',
          readonly: false,
          type: 'number'
        }
      ],
      appendNode: false, //是否在画布添加节点
      scrollTop: 0, //画布滚动高度
      Rectangle: {
        height: 30, //节点形状
        width: 120
      },
      outNodeMargin: 10, //节点的外点边距
      pointData: [],
      nodeIndex: -1,
      nodeData: [
        {
          id: '01',
          name: '测试节点',
          left: 10,
          top: 20,
          scaleDays: 10,
          fixedDays: 11,
          advanceDays: 2,
          delayedDays: 3

        },
        {
          id: '02',
          name: '测试节点2',
          left: 100,
          top: 200,
          scaleDays: 10,
          fixedDays: 11,
          advanceDays: 2,
          delayedDays: 3
        }
      ],
      eageList: [
        {
          id: '001',
          fromId: '01',
          fromPos: 'B',
          toId: '02',
          toPos: 'T'
        }
      ],
      pathPoint: [], //{id, path}
      //是否画线
      isPath: false,
      pathToNode: {},
      anchorArray: [],
      mousePoint: [],
      //old
      dragFlag: true,
      dragClone: '',
      offsetX: 0,
      offsetY: 0,
      dragWidth: 0,
      dragPanelClone: '',
      toolWidth: 230,
      toolHeight: 0,
      Margin: {
        left: 20,
        right: 20,
        top: 20,
        bottom: 20
      },
      nodes: [
        { name: '开始节点', icon: '', disabled: false },
        { name: '结束节点', icon: '', disabled: false },
        { name: '普通节点', icon: '', disabled: false },
        { name: '连接线', icon: '', disabled: false }
      ]
    }
  },
  watch: {
  },
  created() {
    /**
     * 以下是为了解决在火狐浏览器上推拽时弹出tab页到搜索问题
     * @param event
     */
    if (this.isFirefox()) {
      document.body.ondrop = function(event) {
        // 解决火狐浏览器无法获取鼠标拖拽结束的坐标问题
        // mousePosition.left = event.layerX
        // mousePosition.top = event.clientY - 50
        event.preventDefault()
        event.stopPropagation()
      }
    }
  },
  mounted() {
    this.init()
    this.addNodeEvent()
    // const lineGenerator = d3.line()
    this.getPathPointArr(this.eageList)
    /* for (const a in this.eageList) {
      this.pathPoint.push(lineGenerator(this.eageList[a]))
    }*/
    console.log('pathPoint', this.pathPoint)
  },
  methods: {
    //删除路径
    deletPath(id) {
      // d3.select('#' + id).remove()
      for (let i = this.pathPoint.length - 1; i >= 0; i--) {
        if (this.pathPoint[i].id === id) {
          this.pathPoint.splice(i, 1)
        }
      }
      // svg.remove(path)
    },
    //是否有路线
    havePath(id) {
      let flag = false
      for (let i = this.pathPoint.length - 1; i >= 0; i--) {
        if (this.pathPoint[i].id === id) {
          flag = true
          break
        }
      }
      return flag
    },
    //更新路径属性
    updatePath(id, key, value) {
      for (let i = this.pathPoint.length - 1; i >= 0; i--) {
        if (this.pathPoint[i].id === id) {
          this.pathPoint[i][key] = value
          break
        }
      }
    },
    //获取路径坐标点
    getPathPointArr(edge) {
      const lineGenerator = d3.line()
      for (const item in edge) {
        let obj = {}
        const arr = []
        const from = this.getAnchorPos(edge[item].fromId, edge[item].fromPos)
        console.log('from', from)
        const to = this.getAnchorPos(edge[item].toId, edge[item].toPos)
        console.log('to', to)
        arr.push(from)
        arr.push(to)
        obj = {
          id: 'path' + edge[item].fromId + '-' + edge[item].toId,
          path: lineGenerator(arr)
        }
        this.deletPath(obj.id)
        this.pathPoint.push(obj)
      }
    },
    //获取锚点坐标
    getAnchorPos(id, pos) {
      const arr = []
      const node = d3.select('#node' + id)
      console.log('nodeeee', node)
      const xy = this.getGXY(node)
      let x = parseInt(xy[0])
      let y = parseInt(xy[1])
      switch (pos) {
        case 'T':
          x = x + this.Rectangle.width / 2
          break
        case 'B':
          x = x + this.Rectangle.width / 2
          y = y + this.Rectangle.height
          break
        case 'L':
          y = y + this.Rectangle.height / 2
          break
        case 'R':
          x = x + this.Rectangle.width
          y = y + this.Rectangle.height / 2
          break
        default:
          x = 0
          y = 0
      }
      arr.push(x)
      arr.push(y)
      return arr

    },
    //取消所有节点的选中状态
    canceChooseNode() {
      d3.selectAll('.rectNode').attr('stroke', '#E0E3E7')
    },
    getNodeDataById(id) {
      this.nodeData.forEach(item => {
        if (item.id === id) {
          this.formData = item
        }

      })
    },
    //获取锚点
    getFourAnchor(g, id) {
      const arr = []
      const node = d3.select('#node' + id)
      const xy = this.getGXY(node)
      const x = parseInt(xy[0])
      const y = parseInt(xy[1])
      arr.push({ id: id, xy: [x + this.Rectangle.width / 2, y], pos: 'T' })
      arr.push({ id: id, xy: [x + this.Rectangle.width / 2, y + this.Rectangle.height], pos: 'B' })
      arr.push({ id: id, xy: [x, y + this.Rectangle.height / 2], pos: 'L' })
      arr.push({ id: id, xy: [x + this.Rectangle.width, y + this.Rectangle.height / 2], pos: 'R' })
      return arr
    },
    //每个节点添加事件
    addEventByGroup(g, id) {
      const self = this
      // const outCircleG = g.select('#outCircle' + id)
      const anchorG = g.select('#anchor' + id)
      //添加锚点显示事件
      g.on('mouseover', function() {
        anchorG.selectAll('circle').attr('fill', '#000')
        g.selectAll('circle').attr('cursor', 'crosshair')
        self.anchorArray = self.getFourAnchor(g, id)
      })
        .on('mouseout', function() {
          g.select('#anchor' + id).selectAll('circle').attr('fill', 'none')
          g.selectAll('circle').attr('cursor', 'inherit')
          self.anchorArray = []
        })
      //节点加事件
      const node = g.select('#node' + id)
      node.on('click', () => {
        self.canceChooseNode()
        node.attr('stroke', 'blue')
        self.getNodeDataById(id)


      })

      const nodeDrag = d3.drag()
        .on('start', nodeDragStart) // 拖动开始，触发一次
        .on('drag', nodeDraging) // 拖动中，触发多次
        .on('end', nodeDragEnd) // 拖动结束，触发一次
      node.call(nodeDrag)
      let oldNode = []
      let offsetX = 0
      let offsetY = 0
      function nodeDragStart() {
        oldNode = self.getGXY(node)
        offsetX = d3.event.x - oldNode[0]
        offsetY = d3.event.y - oldNode[1]
        console.log('id', id)
      }
      function nodeDraging() {
        self.updateNodeData(id, d3.event.x - offsetX, d3.event.y - offsetY, '')
        self.getPathPointArr(self.eageList)
      }
      function nodeDragEnd() {
        if (d3.event.x < self.outNodeMargin || d3.event.y < self.outNodeMargin) {
          console.log('oldNode', oldNode)
          self.updateNodeData(id, parseInt(oldNode[0]), parseInt(oldNode[1]), '')
          self.getPathPointArr(self.eageList)
          self.$messageInfo('error', '警告')
        } else {
          self.updateNodeData(id, d3.event.x - offsetX, d3.event.y - offsetY, '')
          self.getPathPointArr(self.eageList)
        }
      }
      this.circleAnchorDrag(g, id)

    },
    //获取最近的锚点坐标
    getLeastPoint(array, sourceArr) {
    //  todo
      console.log('nowArray', array)
      console.log('sourceArr', sourceArr)
      let min = 0
      let index = 0
      for (const a in sourceArr) {
        const x = sourceArr[a].xy[0] - array[0]
        const y = sourceArr[a].xy[1] - array[1]
        const temp = Math.sqrt(x * x + y * y)
        console.log('a', typeof a)
        if (a === '0') {
          min = temp
          index = a
        } else {
          if (min > temp) {
            min = temp
            console.log('min', min)
            index = a
          }

        }
      }
      return sourceArr[index]

    },
    getNodeAnchorPosByXY(id, x, y) {
      console.log('mouseX', x)
      console.log('mouseY', y)
      let pos = ''
      const node = d3.select('#node' + id)
      const xy = this.getGXY(node)
      const nodeX = parseInt(xy[0])
      const nodeY = parseInt(xy[1])
      if (x - nodeX === this.Rectangle.width / 2) {
        if (nodeY === y)
          pos = 'B'
        else
          pos = 'T'
      } else if (x === nodeX) {
        pos = 'L'
      } else {
        pos = 'R'
      }
      return pos
    },
    //拖动锚点画线
    circleAnchorDrag(g, id) {
      let pointArray = []
      const self = this
      let pathId = ''
      let fromPos = ''
      const lineGenerator = d3.line()
      const dragPoint = d3.drag()
        .on('start', dragedPointStart) // 拖动开始，触发一次
        .on('drag', dragPointing) // 拖动中，触发多次
        .on('end', dragPointEnd) // 拖动结束，触发一次
      //
      g.select('#anchor' + id).selectAll('circle')
        .call(dragPoint)
      function dragedPointStart(d, i, a) {
        self.isPath = true
        self.dragClone = d3.select(this)
          .clone(true)
        //获取起始节点[x，y]
        const array = [parseInt(self.dragClone.attr('cx')), parseInt(self.dragClone.attr('cy'))]
        pointArray = []
        pointArray.push(array)
        fromPos = self.getNodeAnchorPosByXY(id, array[0], array[1])
        console.log('shsiz ', pointArray)
        // drawLine((pointArray))
      }
      function dragPointing() {
        // pathId = 'path' + id + '-' + self.pathToNode.id
        pathId = 'path' + id + '-' + 'temp'
        let array = [d3.event.x, d3.event.y]

        console.log('shsiz ', pointArray)
        self.deletPath(pathId)
        //获取吸附点
        if (self.anchorArray.length > 0) {
          self.pathToNode = self.getLeastPoint(array, self.anchorArray)
          array = self.pathToNode.xy
          // pathId = 'path' + id + '-' + self.pathToNode.id
        }
        if (pointArray.length > 1) {
          pointArray.pop()
        }
        pointArray.push(array)
        self.pathPoint.push({
          id: pathId,
          path: lineGenerator(pointArray)
        })
        console.log('self.pathPoint', self.pathPoint)
        // drawLine((pointArray))
      }
      function dragPointEnd() {
        if (self.pathToNode.id === id) {
          self.deletPath(pathId)
          self.$messageInfo('error', '请将线连接到其他节点上')
        } else {
          const newPathId = 'path' + id + '-' + self.pathToNode.id
          if (!self.havePath(newPathId)) {
            self.updatePath(pathId, 'id', newPathId)
            const obj = {
              id: '',
              fromId: id,
              fromPos: fromPos,
              toId: self.pathToNode.id,
              toPos: self.pathToNode.pos,
              updateFlag: false
            }
            self.eageList.push(obj)
          } else {
            self.deletPath(pathId)
            self.$messageInfo('error', '当前两节点间已经有连接关系，请勿重复连线')
          }
        }
        self.dragClone.remove()
        self.isPath = false
        self.pathToNode = {}
      }
      // g.select('#outCircle' + id).selectAll('circle')
      //   .on('mouseover', () => {
      //     if (self.isPath) {
      //       if (pointArray.length > 1) {
      //         pointArray.pop()
      //       }
      //       const array = [parseInt(this.attr('cx')), parseInt(this.attr('cy'))]
      //       pointArray.push(array)
      //       self.deletPath(pathId)
      //       self.pathPoint.push({
      //         id: pathId,
      //         path: lineGenerator(pointArray)
      //       })
      //     }
      //   })
    },
    //根据id改变数据
    updateNodeData(id, left, top, text) {
      for (const a in this.nodeData) {
        if (id === this.nodeData[a].id) {
          if (left > 0) {
            this.nodeData[a].left = left
          }
          if (top > 0) {
            this.nodeData[a].top = top
          }
          if (text !== '') {
            this.nodeData[a].name = text
          }
          break
        }

      }

    },
    //给节点添加事件
    addNodeEvent() {
      for (const a in this.nodeData) {
        const id = this.nodeData[a].id
        const g = d3.select('#group' + id)
        this.addEventByGroup(g, id)

      }
    },
    // 是否是火狐浏览器
    isFirefox() {
      const userAgent = navigator.userAgent
      if (userAgent.indexOf('Firefox') > -1) {
        return true
      }
      return false
    },
    //初始化一些东西
    init() {
      //获取svg
      const svg = d3.select('#dagSvg')
      //添加defs标签
      const defs1 = svg.append('defs')
      //添加marker标签及其属性
      const arrowMarker = defs1.append('marker')
        .attr('id', 'arrow')
        .attr('markerUnits', 'strokeWidth')
        .attr('markerWidth', 8)
        .attr('markerHeight', 8)
        .attr('viewBox', '0 0 8')
        .attr('refX', 4)
        .attr('refY', 4)
        .attr('orient', 'auto')
      //绘制直线箭头
      const arrow_path = 'M2,2 L6,4 L2,6 L4,4 L2,2'
      arrowMarker.append('path')
        .attr('d', arrow_path)
        .attr('fill', '#000')
    },
    // 返回唯一标识
    getUUID() {
      return Math.random().toString(36).substr(3, 10)
    },
    //工具栏拖动
    appendSvgNode(newDiv, parDiv, e, odiv) {
      //节点相对开始节点偏移高度
      let offTop = 0
      //随机生成id
      const id = this.getUUID()
      console.log('uuid', id)
      //节点id
      const oldNodeId = odiv.id
      //节点偏移高度
      const oldTop = odiv.offsetTop
      //相对svg x坐标
      const left = parseFloat(newDiv.style.left) - 460
      //计算节点偏移量
      if (oldNodeId === 'flowNode') {
        offTop = 50
      } else if (oldNodeId === 'endNode') {
        offTop = 100
      }
      //相对svg y坐标（含滚动条高度）
      const top = parseFloat(newDiv.style.top) - oldTop + this.$refs.canvs.scrollTop + offTop
      // this.addCanvsNode(id, left, top)
      const data = {
        id: id,
        left: left,
        top: top,
        name: 'wenzi',
        scaleDays: 0,
        fixedDays: 0,
        advanceDays: 0,
        delayedDays: 0

      }
      //判断是否可以添加节点
      if (this.appendNode) {
        //添加数据
        this.nodeData.push(data)
        //添加事件
        clearTimeout(this.timer) //清除延迟执行
        this.timer = setTimeout(() => { //设置延迟执行
          const g = d3.select('#group' + id)
          this.addEventByGroup(g, id)
        }, 500)
      }
      //删除拖拽克隆的节点
      parDiv.removeChild(newDiv)

    },
    //画布添加节点
    addCanvsNode(id, left, top) {
      let pointArray = []
      console.log('style-h', this.$refs.canvs.scrollTop)
      console.log('style-w', top)
      //判断是否可以添加节点
      if (this.appendNode) {
        //获取svg
        const svg = d3.select('#dagSvg')
        //添加g标签
        const g = svg.append('g')
          .attr('id', 'group' + id)
          .on('mouseover', function() {
            d3.select('#group' + id).selectAll('circle')
              .attr('fill', '#000')
              .attr('cursor', 'crosshair')
          })
          .on('mouseout', function() {
            d3.select('#group' + id).selectAll('circle')
              .attr('fill', 'none')
              .attr('cursor', 'inherit')
          })

        //添加矩形节点
        this.drawRect(g, 'outRect' + id, 4, 4, this.Rectangle.height, this.Rectangle.width,
          'transparent', '#E0E3E7', 1, 'round', 'round', 'move', left, top)
        // g.append('rect')
        //   .attr('id', 'node' + id)
        //   .attr('rx', 4)
        //   .attr('ry', 4)
        //   .attr('height', this.Rectangle.height)
        //   .attr('width', this.Rectangle.width)
        //   .attr('fill', 'transparent')
        //   .attr('stroke', '#E0E3E7')
        //   .attr('stroke-width', 1)
        //   .attr('stroke-linecap', 'round')
        //   .attr('stroke-linejoin', 'round')
        //   .attr('transform', `translate(${left}, ${top})`)
        //   .style('cursor', 'move')

        //添加外点矩形

        g.append('rect')
          .attr('class', 'outRect')
          .attr('id', 'outRect' + id)
          .attr('height', this.Rectangle.height + this.outNodeMargin * 2)
          .attr('width', this.Rectangle.width + this.outNodeMargin * 2)
          .attr('fill', 'transparent')
          .attr('stroke', '#E0E3E7')
          .attr('stroke-dasharray', '10')
          .attr('stroke-width', 1)
          .attr('stroke-linecap', 'round')
          .attr('stroke-linejoin', 'round')
          .attr('transform', `translate(${left - this.outNodeMargin}, ${top - this.outNodeMargin})`)

        //添加锚点
        g.append('circle')
          .attr('r', 2)
          .attr('cx', left + this.Rectangle.width / 2)
          .attr('cy', top)
          .attr('fill', 'none')
          .attr('cursor', 'inherit')
          .on('mousedown', () => {
            console.log('锚点ex', d3.event.x)
            console.log('锚点ey', d3.event.y)
          })
          .on('mousemove', () => {
            console.log('锚点ex', d3.event.x)
            console.log('锚点ey', d3.event.y)
          })

        g.append('circle')
          .attr('r', 2)
          .attr('cx', left + this.Rectangle.width / 2)
          .attr('cy', top + this.Rectangle.height)
          .attr('fill', 'none')
          .attr('cursor', 'inherit')

        g.append('circle')
          .attr('r', 2)
          .attr('cx', left)
          .attr('cy', top + this.Rectangle.height / 2)
          .attr('fill', 'none')
          .attr('cursor', 'inherit')

        g.append('circle')
          .attr('r', 2)
          .attr('cx', left + this.Rectangle.width)
          .attr('cy', top + this.Rectangle.height / 2)
          .attr('fill', 'none')
          .attr('cursor', 'inherit')

        //添加文字
        g.append('text')
          .attr('id', '03')
          .attr('x', left + this.Rectangle.width / 4)
          .attr('y', top + this.Rectangle.height * 0.7)
          .attr('font-family', 'Verdana')
          .attr('font-size', 12)
          .attr('fill', '')
          .attr('text-anchor', 'start')
          .attr('cursor', 'move')
          .text('开始节点0001')





        const dragPoint = d3.drag()
          .on('start', dragedPointStart) // 拖动开始，触发一次
          .on('drag', dragPointing) // 拖动中，触发多次
          .on('end', dragPointEnd) // 拖动结束，触发一次
        //
        svg.selectAll('circle')
          .call(dragPoint)
      }
      function dragedPointStart() {
        this.dragClone = d3.select(this)
          .clone(true)
        console.log('this', this.dragClone)
        const array = [this.dragClone.attr('cx'), this.dragClone.attr('cy') - 1]
        pointArray = []
        pointArray.push(array)
        console.log('shsiz ', pointArray)
        // drawLine((pointArray))
      }
      function dragPointing() {
        const array = [d3.event.x, d3.event.y]
        if (pointArray.length > 1) {
          pointArray.pop()
        }
        pointArray.push(array)
        console.log('shsiz ', pointArray)
        drawLine((pointArray))
      }
      function dragPointEnd() {
        this.dragClone.remove()
      }
      function drawLine(data) {

        const lineGenerator = d3.line()
        const pathString = lineGenerator(data)
        const g = d3.selectAll('g')
        g.selectAll('path').remove()
        g.append('path')
          .attr('d', pathString)
          .attr('stroke', 'steelblue')
          .attr('stroke-width', 3)
          .attr('fill', 'none')
          // .attr('marker-start', 'url(#circle)')
          .attr('marker-end', 'url(#arrow)')
      }

    },
    /**
     * 画矩形
     *
     * @author        HangerZou
     * @createDate    2021-06-28
     * @version       v1.0
     * @param sel       selection/selections
     * @param id      id
     * @param rx      圆角
     * @param ry      圆角
     * @param height  矩形高度
     * @param width   矩形宽度
     * @param color   填充色
     * @param left    水平平移距离
     * @param top     垂直平移距离
     */
    drawRect(sel, id, rx, ry, height, width, color, stroke, strokeWidth, strokeLinecap, strokeLinejoin, cursor, left, top) {
      sel.append('rect')
        .attr('id', id)
        .attr('rx', rx)
        .attr('ry', ry)
        .attr('height', height)
        .attr('width', width)
        .attr('fill', color)
        .attr('stroke', stroke)
        .attr('stroke-width', 2)
        .attr('stroke-linecap', strokeWidth)
        .attr('stroke-linejoin', strokeLinecap)
        .style('cursor', cursor)
        .attr('transform', `translate(${left}, ${top})`)
    },
    /**
     * 获取G元素的XY坐标位置
     *
     * @author      ZhengWei(HY)
     * @createDate  2018-10-23
     * @version     v1.0
     */
    getGXY(i_G) {
      var v_Ret = i_G.attr('transform').replace('translate(', '').replace(')', '')

      if (v_Ret.indexOf(',') >= 0) {
        return v_Ret.split(',')
      } else if (v_Ret.indexOf(' ') >= 0) {
        /* IE浏览器有用空格分割位置XY的情况 */
        return v_Ret.split(' ')
      } else {
        return (v_Ret + ',0').split(',')
      }
    },
    //睡眠函数
    sleep(numberMills) {
      let now = new Date()
      let flag = false
      const exitTime = now.getTime() + numberMills
      // eslint-disable-next-line no-constant-condition
      while (true) {
        now = new Date()
        if (now.getTime() > exitTime) {
          flag = true
          return flag
        }
      }
    }
  }
}
</script>
<style scoped>
  .node {
    /*margin-left: 20px;*/
    border:1px dashed #E0E3E7;
    border-radius: 5px;
    height:30px;
    width:120px;
    padding: 6px;
    position: absolute;
  }
  /deep/ .el-tabs__item {
    height: 4vh;
    font-size: 12px;
  }
  /deep/ .el-tabs__content {
    overflow: hidden;
    position: relative;
    height: 26vh;
  }
/deep/ .el-form-item--mini.el-form-item, .el-form-item--small.el-form-item {
  margin-bottom: 9px;
}
  /deep/ .el-form-item__label {
    text-align: right;
    vertical-align: middle;
    float: left;
    font-size: 13px;
    color: #606266;
    line-height: 40px;
    padding: 0 12px 0 0;
    box-sizing: border-box;
  }
  /deep/ .el-input-number--mini {
    width: 100%;
    line-height: 26px;
  }
</style>
